function jsonStringify(data) {
    return JSON.stringify(data)
}

function jsonParse(data) {
    return JSON.parse(data)
}

export {jsonParse, jsonStringify}